import {
    Unstable_Grid2 as Grid, Card, CardHeader, CardContent, TextField, Box, Typography, Chip
} from '@mui/material';
import { DropdownModel, EditorType, NLCInfo, TableInfo } from '../../../data/interfaces/sharedmodels';
import { useAppDispatch, useAppSelector } from '../../../stores/hooks';
import { updateVersion, updateselectedNlcs } from '../../../stores/itsoslice';
import NLCList from '../../../shared/nlclist';
import Tables from '../../../shared/datamanagementcomponents/datatables';
import { useCallback, useEffect, useState } from 'react';
import { cubictheme } from '../../../../assets/cubictheme';
import EditableDataList from '../../../shared/datamanagementcomponents/editabledatatable';
import EditableAcceptanceDataList from '../../../shared/datamanagementcomponents/editableacceptancelist';
import EditableForm from '../../../shared/datamanagementcomponents/editableform';
import itsoService from '../../../data/api/itso.service';



const tables: TableInfo[] = []


const Tableheader = () => {
    const dispatch = useAppDispatch();
    const selectedTable = useAppSelector((state) => state.itsoReducer.selectedDataTable);
    const selectedNlcs = useAppSelector((state) => state.itsoReducer.selectedNlcs);
    const handleDelete = (nlc: NLCInfo) => () => {
        const currentIndex = selectedNlcs.findIndex(a => a.NLC == nlc.NLC);
        const newChecked = [...selectedNlcs];

        if (currentIndex != -1) {
            newChecked.splice(currentIndex, 1);
        }

        dispatch(updateselectedNlcs(newChecked));
    };
    return (
        <Box>
            <Typography variant='h5'>{selectedTable?.Description}</Typography>
            {selectedNlcs.map((nlc) => {
                return (
                    <Chip key={nlc.NLC}  label={nlc.StationName} onDelete={handleDelete(nlc)} />
                )
            })

            }
        </Box>
    )
}

export default function ItsoTables() {

    const dispatch = useAppDispatch();
    const [tables, setTables] = useState<TableInfo[]>([]);
    const [versions, setVersions] = useState<DropdownModel[]>([]);
   
    const [data, setData] = useState<any>({ Fields: [], Rows: [],VersionDetails:null,FieldGroups:[], FieldLookups: [], CanAddRows: false });
    const [widthArray, setWidthArray] = useState([3, 3, 6]);
    const selectedTable = useAppSelector((state) => state.itsoReducer.selectedDataTable);
    const datatbleexpanded = useAppSelector((state) => state.itsoReducer.datatableExpanded);
    const selectedNlcs = useAppSelector((state) => state.itsoReducer.selectedNlcs);
    const selectedVersion = useAppSelector((state) => state.itsoReducer.selectedVersion);
    const versionChangedCounter=useAppSelector((state)=>state.itsoReducer.versionChangedCounter);
    const filterFields = useAppSelector((state) => state.itsoReducer.filterAttributes);
    const editorType = useAppSelector((state) => state.itsoReducer.editorType);
    useEffect(() => {
        itsoService.getdatatables().then((response) => {
            setTables(response.data.filter((table: { OpensInPopup: boolean; }) => table.OpensInPopup != true ));
        })
    }, []);

    useEffect(() => {
        if (selectedTable) {
            if (selectedTable.IsGlobal) {
                if(selectedNlcs.length>0)
                    dispatch(updateselectedNlcs([]));
                    itsoService.gettableVersions(selectedTable.Id,selectedNlcs.length>0?selectedNlcs[0].Id:null).then((response) => {
                        setVersions(response.data);
                    });
            }
            else if(selectedNlcs.length>0){
                itsoService.gettableVersions(selectedTable.Id,selectedNlcs.length>0?selectedNlcs[0].Id:null).then((response) => {
                    setVersions(response.data);
                });
            }
            else{
                setVersions([]);
            }
            
        }
    }, [selectedTable, selectedNlcs,filterFields]);

    useEffect(() => {
       
        if (selectedTable && selectedVersion) {
            itsoService.getdata(selectedTable?.Id,
                (!selectedTable.IsGlobal && selectedNlcs.length > 0) ? selectedNlcs[0].Id : undefined,selectedVersion,filterFields,
                selectedTable.EditorType==EditorType.TableOrForm?editorType:selectedTable.EditorType).then((response) => {
                    if (response && response.data) {
                        setData(response.data);
                    }
                    else {
                        setData({ Fields: [], Rows: [],VersionDetails:null,FieldGroups:[], FieldLookups: [], TypeLookups: [], CanAddRows: false });
                    }

                })

        }
        else{
            setData({ Fields: [], Rows: [],VersionDetails:null,FieldGroups:[], FieldLookups: [], TypeLookups: [], CanAddRows: false });
        }
    }, [versionChangedCounter,editorType]);

    useEffect(() => {
        if (versions && versions.length > 0) {
            dispatch(updateVersion(versions[0].Id));
        }
        else{
            dispatch(updateVersion(null));
        }
    }, [versions])

    useEffect(() => {
        if (datatbleexpanded) {
            setWidthArray([0, 0, 12]);

        }
        else {
            setWidthArray([2.5, 2.5, 7]);
        }
    }, [datatbleexpanded]);

    const handleSave = useCallback(() => {
        itsoService.gettableVersions(selectedTable?.Id??0,selectedNlcs.length>0?selectedNlcs[0].Id:null).then((response) => {
            setVersions(response.data);
        });
    }, [selectedTable,selectedNlcs]);
   
    return (
        
        <Grid container spacing={widthArray[2] == 12 ? 0 : 1}>
            <Grid xs={widthArray[0]}>
                <Tables parent='itso' tables={tables} />
            </Grid>
            <Grid xs={widthArray[1]}>
                <NLCList parent='itso' disabled={selectedTable == null ? false : selectedTable.IsGlobal} />
            </Grid>
            <Grid xs={widthArray[2]} sx={{ transition: cubictheme.transitions.easing.sharp }}>
                
                {selectedTable?.EditorType == EditorType.Table ||(selectedTable?.EditorType==EditorType.TableOrForm&&editorType==EditorType.Table)?
                    <EditableDataList  parent='itso' heading={selectedTable?.Description} data={data} versions={versions} callback={handleSave} /> :
                    selectedTable?.EditorType == EditorType.Acceptance ?
                        <EditableAcceptanceDataList parent='itso' heading={selectedTable?.Description} data={data} versions={versions} callback={handleSave}/> :
                        selectedTable?.EditorType==EditorType.Form||(selectedTable?.EditorType==EditorType.TableOrForm&&editorType==EditorType.Form)?<EditableForm  parent='itso' heading={selectedTable?.Description} 
                        versions={versions} callback={handleSave} data={data}/>:
                        <div>Coming Soon</div>
                }
            </Grid>
        </Grid>
       
    );
}